const USER_DATA = "USER_DATA";
const CREATE_POST_DATA = "CREATE_POST_DATA";
const VIRTUAL_POST_DATA = "VIRTUAL_POST_DATA";

export { USER_DATA, CREATE_POST_DATA, VIRTUAL_POST_DATA };
